import { faFileArrowUp, faRemove } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  InputItem,
  LoadingIndicator,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { Badge } from '@windmill/react-ui';
import React, { useState } from 'react';

type DragDropUploadProps = {
  title: string;
  acceptedFileTypes: string[];
  multipleFiles: boolean;
  isUploading?: boolean;
  initialFilename?: string;
  onFileSelected: (file: File) => void;
  onFileUnselected: (file: string) => void;
  onInvalidFile: (msg: string) => void;
  error: string;
};

export const DragDropUpload: React.FunctionComponent<DragDropUploadProps> = ({
  title,
  acceptedFileTypes,
  multipleFiles,
  isUploading = false,
  initialFilename,
  onFileSelected,
  onFileUnselected,
  onInvalidFile,
  error,
}): JSX.Element => {
  const [chosenFile, setChosenFile] = useState<File>();

  const onChange = (files: FileList) => {
    if (files.length > 0) {
      const file = files[0];

      if (acceptedFileTypes.findIndex((type) => type === file.type) > -1) {
        setChosenFile(file);
        isUploading = true;
        onFileSelected(file);
      } else {
        onInvalidFile(`${file.type} is not a supported file type.`);
      }
    }
  };

  const chosenFilename = chosenFile ? chosenFile.name : initialFilename;

  return (
    <InputItem title={title}>
      <div>
        {!chosenFilename && (
          <label
            className="flex justify-center p-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none"
            htmlFor="app-icon"
          >
            <div>
              <span className="flex justify-center flex-col items-center space-x-2">
                <div className="flex justify-center flex-col font-medium text-gray-600">
                  <FontAwesomeIcon className="fa-solid" icon={faFileArrowUp} />
                  <div className="font-bold text-center">Upload a file</div>
                  <div className="text-sm text-center">
                    PNG, JPG, GIF up to 10MB
                  </div>
                </div>
              </span>
              <input
                accept={acceptedFileTypes.join(',')}
                className="hidden"
                id="app-icon"
                multiple={multipleFiles}
                name="app-icon"
                onChange={(e) => {
                  onChange(e.target.files || new FileList());
                }}
                type="file"
              />
            </div>
          </label>
        )}
        {chosenFilename && !isUploading && (
          <div className="relative">
            <Badge>{chosenFilename}</Badge>
            <button
              className="absolute -top-2"
              onClick={() => {
                if (chosenFilename) {
                  onFileUnselected(chosenFilename);
                }

                if (chosenFile) {
                  setChosenFile(undefined);
                }
              }}
              type="button"
            >
              <FontAwesomeIcon className="text-red-700" icon={faRemove} />
            </button>
          </div>
        )}
        <p>{error}</p>
      </div>
      {chosenFile && isUploading && (
        <div className="px-12 py-8">
          <LoadingIndicator />
        </div>
      )}
    </InputItem>
  );
};
